export const METRIC_UNITS = {
  speed: 'km/h',
  length: 'cm',
  area: 'ha',
  pressure: 'mbar',
  investment: 'kseed/ha',
  productivity: 'ha/h',
  // tipi per irriapp
  distance: 'm',           // work_tube_length
  volume: 'm³',           // work_water_used  
  linear_speed: 'm/h',     // work_sector_speed
  height: 'mm',            // work_sector_height
  irriapp_sector_length: 'cm',
};

export const IMPERIAL_UNITS = {
  speed: 'mph',
  length: 'in',
  area: 'acres',
  pressure: 'psi', 
  investment: 'kseed/acre',
  productivity: 'acres/h',
  // tipi per irriapp
  distance: 'ft',          // work_tube_length
  volume: 'ft³',          // work_water_used
  linear_speed: 'ft/h',    // work_sector_speed  
  height: 'in',           // work_sector_height   
  irriapp_sector_length: 'in',         
};

export const convertValue = (value, measurementType, toImperial = false) => {
  if (!value || value === 0) return value;
  
  const conversions = {
    speed: toImperial ? value * 0.621371 : value,
    length: toImperial ? value * 0.393701 : value,
    area: toImperial ? value * 2.47105 : value,
    pressure: toImperial ? value * 0.0145038 : value,
    investment: toImperial ? value / 2.47105 : value,
    productivity: toImperial ? value * 2.47105 : value,
    // conversioni per irriapp
    distance: toImperial ? value * 3.28084 : value,        // m to ft
    volume: toImperial ? value * 35.3147 : value,          // m³ to ft³
    linear_speed: toImperial ? value * 3.28084 : value,    // m/h to ft/h
    height: toImperial ? (value / 10) * 0.393701 : value,   // mm to cm to in
    irriapp_sector_length: toImperial ? (value / 10) * 0.393701 : value   // mm to cm to in
  };
  
  return Math.round(conversions[measurementType] * 100) / 100;
};

export const getUnit = (measurementType, isImperial = false) => {
  return isImperial ? IMPERIAL_UNITS[measurementType] : METRIC_UNITS[measurementType];
};

export const formatValueWithUnit = (value, measurementType, isImperial = false) => {
  if (!value) return ' - ';
  const convertedValue = convertValue(value, measurementType, isImperial);
  const unit = getUnit(measurementType, isImperial);
  return `${convertedValue} ${unit}`;
};